import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  getAllUsersForAdvisor,
  getUserData,
  editRole,
  getRolePermissions,
} from '../../store/actions';
import {
  getAuthState,
  getTenantState,
  getOnboardingState,
  getAdminState,
} from '../../store/selectors';
import Table from './Table';
import Loading from '../utility/Loading';

class ManageUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  handleSubmit = async (roleToChange, userToChange) => {
    let schools = [];
    let districts = [];
    if (
      roleToChange.includes('School') &&
      this.props.tenant.features.includes('highschool')
    ) {
      schools = [
        { id: 14159, titleEn: '4 Success Schools' },
        { id: 14160, titleEn: '91st Psalm Christian School' },
      ];
    } else if (
      roleToChange.includes('District') &&
      this.props.tenant.features.includes('highschool')
    ) {
      districts = [
        { id: 1, name: 'Private Schools' },
        { id: 12, name: 'ASU Preparatory Academies' },
      ];
    }
    const editInfo = {
      userToChange,
      roleToChange,
      schools,
      districts,
    };
    await this.props.editRole(
      this.props.tenant.id,
      this.props.auth.jwtToken,
      editInfo
    );
  };

  componentWillUnmount = () => {
    this._isMounted = false;
  };

  componentDidMount = async () => {
    this._isMounted = true;
    if (this._isMounted) {
      await this.props.getRolePermissions(this.props.auth.jwtToken);
      await this.props.getAllUsersForAdvisor(this.props.tenant.id);
    }
    if (!this.props.onboarding.userData.user && this._isMounted) {
      await this.props.getUserData(
        this.props.onboarding.userData.user.id,
        this.props.auth.jwtToken
      );
    }
    this.setState({ loading: false });
  };

  render() {
    if (this.state.loading) {
      return <Loading height="100vh" />;
    }
    return (
      <div style={{ overflow: 'scroll', height: '100vh' }}>
        <div className="level container">
          {/* this can be 'manage users or permissions when we have the concept of admin/tenants/etc */}
          <div className="level-left">View Users</div>
        </div>
        {this.props.users.length > 0 ? (
          <Table
            handleSubmit={this.handleSubmit}
            editableRoles={this.props.admin.permissions.editableRoles}
            data={this.props.users}
            delete={this.props.adminDeleteUser}
            edit={this.toggleEditForm}
          />
        ) : (
          'Sorry, you have no users to view'
        )}
        <br />
        <br />
        <br />
        <br />
        <br />
        {this.props.tenant.features.includes('highschool') && (
          <>
            <div style={{ fontWeight: 'bold' }}>
              If you assign a user a School role, they will be assigned to these
              schools, just for test purposes:
            </div>
            {[
              { id: 14159, titleEn: '4 Success Schools' },
              { id: 14160, titleEn: '91st Psalm Christian School' },
            ].map((school) => {
              return <p key={school.id}>{school.titleEn}</p>;
            })}
            <br />
            <br />
            <div style={{ fontWeight: 'bold' }}>
              If you assign a user a district role, they will be assigned to
              these districts, just for test purposes:
            </div>
            {[
              { id: 1, name: 'Private Schools' },
              { id: 12, name: 'ASU Preparatory Academies' },
            ].map((district) => {
              return <p key={district.id}>{district.name}</p>;
            })}
          </>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = {
  getAllUsersForAdvisor,
  getUserData,
  editRole,
  getRolePermissions,
};

const mapStateToProps = (state) => {
  const users = state.admin.users;
  const tenant = getTenantState(state);
  const auth = getAuthState(state);
  const onboarding = getOnboardingState(state);
  const admin = getAdminState(state);
  return { users, tenant, auth, onboarding, admin };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageUsers);
